<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">Adicionar lugar</h2>
      <FormPlace @submit-requested="submitRequested"></FormPlace>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import FormPlace from '../forms/FormPlace.vue'

  export default {
  components: { FormPlace },
    methods: {
      ...mapActions('places', ['addPlace']),
      submitRequested (inputPlace) {
        this.addPlace(inputPlace);
      },
    }
  }
</script> 
 
<style scoped>
</style> 